import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpRepeatFinished', pkpRepeatFinished);

    /**
     * Fires an event when rendering of the ngRepeat is done.
     *
     * @author flzemke.btc
     * @ngInject
     */
    function pkpRepeatFinished($timeout) {
        return {
            restrict: 'A',
            scope: false,
            link: linkFn
        };

        function linkFn(scope, elem, attr) {
            if (scope.$last) {
                $timeout(function () {
                    scope.$eval(attr.pkpRepeatFinished);
                });
            }
        }
    }
})();
